/**
  * Handle oidc bridge redirects.
  * 
  * This handles two redirect scenarios related to the oidc bridge:
  * 
  * 1. Handle the buy button auth request.
  *   - When a buy button is clicked, the user is directed to this component (unauthenticated).
  *     We call a backend API to setup a nonce and an oidc redirect to the OP to obtain user consent.
  *
  *     The path for this should be oidcinit/<op>/<app>
  *     For example: oidcinit/g2/impact
  *     The full path would be something like https://poc.appbind.com/partner/oidcinit/g2/impact
  *
  * 2. Handle the redirect from the OP
  *   - This handles a redirect from an OP when a user on the OP has consented
  *     to an app connection.  We call a backend API to complete the connection.
  * 
  *     The path for this should be oidc/<op>?state=<state>&(additional parms)
  *     For example: oidc/g2?state=1234
  *     The full path would be something like https://poc.appbind.com/partner/oidc/g2?state=1234
  * 
  */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';

class OAuth2Redirect extends Component {
  state = {
    simulation: false,
    mountComplete: 0,
    redirectUri: null,
    localRedirect: null,
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const { isAuthenticated, logoutWithoutRedirect } = this.props.auth;

    if (isAuthenticated()) {
      // Logout current user
      logoutWithoutRedirect();
    }

    // Get the OP id
    let theOp = this.props.match.params.op; // e.g. https://poc.appbind.com/oidc/<op>.
    
    // Get the app id - this only exists in mode 1 (buy button)
    let theRp = this.props.match.params.rp;

    // Get the state - this only exists in mode 2 (redirect after consent)
    let returnedState = params.get('state');

    // Get the simulation flag
    let theSimulation = false;
    let simulation = params.get('simulation');
    if (simulation != null && simulation === 'true') {
      theSimulation = true;
    }

    // Get the search string
    let search = this.props.location.search;

    console.log('theOp: ' + theOp + ', theRp: ' + theRp + ', returnedState: ' + returnedState + ', search: ' + search);

    Promise.resolve()
    .then(() => {
      return this.getRedirectUri(theOp, theRp, returnedState, search, theSimulation);
    })
    .then(redirectUri => {
      if (redirectUri != null) {
        if (simulation === true) {
          this.setState({ mountComplete: 1, redirectUri: redirectUri, simulation: true});
        } else {
          this.setState({ mountComplete: 1, redirectUri: redirectUri});
        }
        return;
      } else {
        this.setState({ mountComplete: 1, localRedirect: "/home"});
        return;
      }
    })
    .catch(err => {
      this.setState({ mountComplete: 1, localRedirect: "/home"});
      return;
    });
  }

  getRedirectUri(theOp, theRp, returnedState, search, simulation) {
    const { callPartnerApi } = this.props.auth;

    let target = 'oidc/' + theOp;

    let theMode = 1;
    let requestParams = search;
    let payload = null;

    if (returnedState != null) {
      theMode = 2;
      requestParams = search;

      payload = {
        mode: theMode,
        state: returnedState,
        params: requestParams,
        simulation: simulation
      };
    } else if (theRp != null) {
      payload = {
        mode: theMode,
        rpParam: theRp,
        simulation: simulation,
        simulationParams: requestParams
      };
    }

    return new Promise(function(resolve, reject) {
      if (payload == null) {
        reject('payload is null');
      }

      callPartnerApi(target,
                     'POST',
                     payload,
                     true)
      .then(response => {
        return response.json();
      })
      .then(data => {
        //let theStatus = data.status;
        //let theStatusReason = data.statusReason;
        let theUri = data.redirectUri;
        resolve(theUri);
      })
      .catch(err => {
        // console.log('err');
        reject(err);
      });
    });
  }
  
  render() {

    if (this.state.mountComplete === 0) {
      return (
        <div>
          <LoadingSpinner />
        </div>
      );
    }

    if (this.state.redirectUri != null) {
      if (this.state.simulation === true) {
        return ( <Redirect to={this.state.redirectUri} /> );
      } else {
        window.location = this.state.redirectUri;
      }
    }

    if (this.state.localRedirect != null) {
      return ( <Redirect to={this.state.localRedirect} /> );
    }
    
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default OAuth2Redirect;